import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

const EMAILJS_SERVICE_ID = 'service_thw2yke';
const EMAILJS_TEMPLATE_ID = 'template_5x9nd4q';
const EMAILJS_PUBLIC_KEY = 'cGe3BBRvAw3QQr7Vc';

const COUNTRY_CODES = [
    ['AE', 'UAE', '+971'], ['IN', 'IND', '+91'], ['US', 'USA', '+1'], ['GB', 'GBR', '+44'],
    ['SA', 'SAU', '+966'], ['QA', 'QAT', '+974'], ['KW', 'KWT', '+965'],
    ['BH', 'BHR', '+973'], ['OM', 'OMN', '+968'], ['PK', 'PAK', '+92'],
    ['BD', 'BGD', '+880'], ['LK', 'LKA', '+94'], ['NP', 'NPL', '+977'],
    ['AF', 'AFG', '+93'], ['CA', 'CAN', '+1'], ['AU', 'AUS', '+61'],
    ['NZ', 'NZL', '+64'], ['DE', 'DEU', '+49'], ['FR', 'FRA', '+33'],
    ['IT', 'ITA', '+39'], ['ES', 'ESP', '+34'], ['NL', 'NLD', '+31'],
    ['BE', 'BEL', '+32'], ['CH', 'CHE', '+41'], ['AT', 'AUT', '+43'],
    ['IE', 'IRL', '+353'], ['PT', 'PRT', '+351'], ['SE', 'SWE', '+46'],
    ['NO', 'NOR', '+47'], ['DK', 'DNK', '+45'], ['FI', 'FIN', '+358'],
    ['PL', 'POL', '+48'], ['GR', 'GRC', '+30'], ['TR', 'TUR', '+90'],
    ['RU', 'RUS', '+7'], ['UA', 'UKR', '+380'], ['CN', 'CHN', '+86'],
    ['JP', 'JPN', '+81'], ['KR', 'KOR', '+82'], ['SG', 'SGP', '+65'],
    ['MY', 'MYS', '+60'], ['ID', 'IDN', '+62'], ['PH', 'PHL', '+63'],
    ['TH', 'THA', '+66'], ['VN', 'VNM', '+84'], ['ZA', 'ZAF', '+27'],
    ['EG', 'EGY', '+20'], ['NG', 'NGA', '+234'], ['KE', 'KEN', '+254'],
    ['BR', 'BRA', '+55'], ['MX', 'MEX', '+52'], ['AR', 'ARG', '+54']
];

export default function Inquiry() {
    const form = useRef();
    const [focused, setFocused] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [countryCode, setCountryCode] = useState('AE');
    const selectedCountry = COUNTRY_CODES.find(([iso]) => iso === countryCode) || COUNTRY_CODES[0];
    const dialCode = selectedCountry[2];

    const handleFocus = (name) => setFocused(prev => ({ ...prev, [name]: true }));
    const handleBlur = (e) => {
        if (!e.target.value) setFocused(prev => ({ ...prev, [e.target.name]: false }));
    };

    const handleValidSubmit = async (e) => {
        e.preventDefault();

        if (!form.current.checkValidity()) {
            form.current.reportValidity();
            return;
        }

        setSubmitting(true);

        try {
            await emailjs.sendForm(
                EMAILJS_SERVICE_ID,
                EMAILJS_TEMPLATE_ID,
                form.current,
                { publicKey: EMAILJS_PUBLIC_KEY }
            );

            toast.success('Your message has been sent successfully.');
            form.current.reset();
            setFocused({});
        } catch (error) {
            console.error('EmailJS failed to send the contact form:', error);
            toast.error('Unable to send your message. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section className="contact-section-new">
            <div className="container">
                {/* Section Header */}
                <div className="contact-header-new text-center">
                    <span className="contact-badge-new">Get In Touch</span>
                    <h2 className="contact-heading-new">Let's Build Something <span className="contact-heading-accent">Great Together</span></h2>
                    <p className="contact-subtext-new">Reach out to our expert team. We respond within 24 hours.</p>
                </div>

                <div className="contact-wrapper-new">
                    {/* Left Info Panel */}
                    <div className="contact-info-panel">
                        <div className="info-panel-inner">
                            <div className="info-panel-bg-shape"></div>

                            <div className="info-tag">Contact Information</div>
                            <h3 className="info-panel-title">Take The First Step Forward</h3>
                            <p className="info-panel-desc">Engage with our support team via phone, email, or simply fill out the form to get started.</p>

                            <div className="info-items-list">
                                <div className="info-item-new">
                                    <div className="info-icon-wrap">
                                        <svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24.2932 18.3474L20.8044 14.8586C19.5584 13.6126 17.4402 14.1111 16.9418 15.7308C16.568 16.8523 15.322 17.4753 14.2006 17.226C11.7086 16.603 8.34438 13.3634 7.72138 10.7468C7.34758 9.62534 8.09518 8.37934 9.21658 8.00558C10.8364 7.50718 11.3348 5.38897 10.0888 4.14297L6.59997 0.654153C5.60317 -0.218051 4.10796 -0.218051 3.23576 0.654153L0.86835 3.02156C-1.49906 5.51357 1.11755 12.1174 6.97377 17.9736C12.83 23.8298 19.4338 26.5711 21.9258 24.079L24.2932 21.7116C25.1655 20.7148 25.1655 19.2196 24.2932 18.3474Z" fill="white" />
                                        </svg>
                                    </div>
                                    <div className="info-text-wrap">
                                        <span className="info-label-new">Phone</span>
                                        <a href="tel:+971564874221">+971-564874221</a>
                                        <a href="tel:+971501227432">+971-501227432</a>
                                    </div>
                                </div>

                                <div className="info-item-new">
                                    <div className="info-icon-wrap">
                                        <svg width="20" height="16" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.5833 9.13418L22 14.7142V3.31855L14.5833 9.13418ZM0 3.31855V14.7142L7.41675 9.13418L0 3.31855ZM20.625 0H1.375C0.688875 0 0.144375 0.608727 0.04125 1.39255L11 9.98509L21.9587 1.39255C21.8556 0.608727 21.3111 0 20.625 0ZM13.3237 10.1225L11.3781 11.6476C11.2658 11.7354 11.1344 11.7821 11 11.7818C10.868 11.7818 10.7374 11.7376 10.6219 11.6476L8.67625 10.1209L0.044 16.6189C0.149875 17.3962 0.691625 18 1.375 18H20.625C21.3084 18 21.8501 17.3962 21.956 16.6189L13.3237 10.1225Z" fill="white" />
                                        </svg>
                                    </div>
                                    <div className="info-text-wrap">
                                        <span className="info-label-new">Email</span>
                                        <a href="mailto:sales@cloudmindme.com">sales@cloudmindme.com</a>
                                    </div>
                                </div>

                                <div className="info-item-new">
                                    <div className="info-icon-wrap">
                                        <svg width="18" height="24" viewBox="0 0 20 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.66669 0C4.33658 0 0 4.33658 0 9.66669C0 11.2668 0.400053 12.8533 1.16057 14.2605L9.13806 28.6885C9.24426 28.8808 9.44664 29 9.66669 29C9.88673 29 10.0891 28.8808 10.1953 28.6885L18.1758 14.2557C18.9333 12.8533 19.3334 11.2667 19.3334 9.66663C19.3334 4.33658 14.9968 0 9.66669 0ZM9.66669 14.5C7.00163 14.5 4.83337 12.3317 4.83337 9.66669C4.83337 7.00163 7.00163 4.83337 9.66669 4.83337C12.3317 4.83337 14.5 7.00163 14.5 9.66669C14.5 12.3317 12.3317 14.5 9.66669 14.5Z" fill="white" />
                                        </svg>
                                    </div>
                                    <div className="info-text-wrap">
                                        <span className="info-label-new">Office</span>
                                        <a href="https://maps.app.goo.gl/gzY11ESAvLixnPUT9" rel="noopener" target="_blank">
                                            38th Floor, Office No: 28, One Business Center, Media One Hotel Tower, Media City, Dubai, UAE.
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="info-social-row">
                                <span className="info-social-label">Follow Us</span>
                                <div className="social-icons-row">
                                    <a href="#" className="social-icon-btn" aria-label="LinkedIn">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
                                    </a>
                                    <a href="#" className="social-icon-btn" aria-label="Twitter">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.732-8.857L1.524 2.25H8.08l4.262 5.636zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
                                    </a>
                                    <a href="#" className="social-icon-btn" aria-label="Facebook">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Form Panel */}
                    <div className="contact-form-panel">
                        <div className="form-panel-inner">
                            <h3 className="form-panel-title">Send Us a Message</h3>
                            <p className="form-panel-subtitle">Our team will get back to you within 24 hours.</p>

                            <form ref={form} onSubmit={handleValidSubmit} className="contact-form-new" noValidate>
                                <div className="row g-0">
                                    <div className="col-lg-6 col-md-6">
                                        <div className={`cf-field-wrap ${focused.name ? 'is-focused' : ''}`}>
                                            <label className="cf-label">Full Name <span>*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="cf-input"
                                                placeholder="John Doe"
                                                required
                                                onFocus={() => handleFocus('name')}
                                                onBlur={handleBlur}
                                            />
                                            <span className="cf-focus-bar"></span>
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6">
                                        <div className={`cf-field-wrap ${focused.email ? 'is-focused' : ''}`}>
                                            <label className="cf-label">Email Address <span>*</span></label>
                                            <input
                                                type="email"
                                                name="email"
                                                className="cf-input"
                                                placeholder="john@example.com"
                                                required
                                                onFocus={() => handleFocus('email')}
                                                onBlur={handleBlur}
                                            />
                                            <span className="cf-focus-bar"></span>
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6">
                                        <div className={`cf-field-wrap ${focused.phone ? 'is-focused' : ''}`}>
                                            <label className="cf-label">Phone Number <span>*</span></label>
                                            <div className="cf-phone-control">
                                                <select
                                                    name="country"
                                                    className="cf-country-select"
                                                    value={countryCode}
                                                    onChange={(e) => setCountryCode(e.target.value)}
                                                    onFocus={() => handleFocus('phone')}
                                                    aria-label="Country calling code"
                                                >
                                                    {COUNTRY_CODES.map(([iso, country]) => (
                                                        <option key={iso} value={iso}>{country}</option>
                                                    ))}
                                                </select>
                                                <input type="hidden" name="country_code" value={dialCode} />
                                                <span className="cf-dial-code">{dialCode}</span>
                                                <input
                                                    type="tel"
                                                    name="phone"
                                                    className="cf-phone-input"
                                                    placeholder="Phone number"
                                                    inputMode="tel"
                                                    required
                                                    onFocus={() => handleFocus('phone')}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                            <span className="cf-focus-bar"></span>
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6">
                                        <div className={`cf-field-wrap cf-select-wrap ${focused.budget ? 'is-focused' : ''}`}>
                                            <label className="cf-label">Budget Range <span>*</span></label>
                                            <select
                                                name="budget"
                                                className="cf-input cf-select"
                                                required
                                                onFocus={() => handleFocus('budget')}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select your budget</option>
                                                <option value="$5,000 - $10,000">$5,000 – $10,000</option>
                                                <option value="$10,000 - $50,000">$10,000 – $50,000</option>
                                                <option value="$50,000 - $100,000">$50,000 – $100,000</option>
                                                <option value="$100,000 - $500,000">$100,000 – $500,000</option>
                                                <option value="$500,000 - $1,000,000">$500,000 – $1,000,000</option>
                                            </select>
                                            <span className="cf-focus-bar"></span>
                                            <span className="cf-select-arrow">
                                                <svg width="12" height="7" viewBox="0 0 12 7" fill="none"><path d="M1 1L6 6L11 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className={`cf-field-wrap ${focused.message ? 'is-focused' : ''}`}>
                                            <label className="cf-label">Your Message</label>
                                            <textarea
                                                name="message"
                                                className="cf-input cf-textarea"
                                                placeholder="Tell us about your project or inquiry..."
                                                rows="5"
                                                onFocus={() => handleFocus('message')}
                                                onBlur={handleBlur}
                                            ></textarea>
                                            <span className="cf-focus-bar"></span>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <button
                                            type="submit"
                                            className={`cf-submit-btn ${submitting ? 'is-submitting' : ''}`}
                                            disabled={submitting}
                                        >
                                            {submitting ? (
                                                <>
                                                    <span className="cf-spinner"></span>
                                                    Sending...
                                                </>
                                            ) : (
                                                <>
                                                    Send Message
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
